class CRMTitleSelector extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { freeInput: false };
	}

	toggleFreeInput(e) {
		$wr.nope(e);
	}

	onChange(e) {
		if (e.target.value == "Other") {
			this.setState({ freeInput: true });
		} else if (this.props.onChange) {
			this.props.onChange(e);
		}
	}

	render(e) {

		if (this.state.freeInput) {
			var input = (
				<input className="form-control" value={ this.props.value }
					autoFocus
					placeholder="Custom title goes here!"
					onChange={ this.onChange } />
			);
		} else {

			var optionGroups = CRMTitleGroups.map((group) => {
				var options = group.options.map((option) => {
					return (
						<option key={ option } value={ option }>{ option }</option>
					);
				})
				return (
					<optgroup key={ group.label } label={ group.label }>
						{ options }
					</optgroup>
				)
			})

			var input = (
				<select className="form-control" value={ this.props.value }
					onChange={ this.onChange }>

					<option value=""></option>
					{ optionGroups }
					<option value="Other">Other</option>

				</select>
			);

		}

		return (
			<div className="crmTitleSelector">
				{ input }
			</div>
		)
	}
};

// 51.8% of titles in CRM on 2020-05-18

const CRMTitleGroups = [
	{
		label: "Teachers",
		options: [
			"Teacher"
		],
	}, {
		label: "School",
		options: [
			"Principal",
			"Assistant Principal",
			"Media Specialist",
			"Library Media Specialist",
			"Librarian",
			"Reading Specialist",
			"Secretary",
		],
	}, {
		label: "District",
		options: [
			"Assistant Superintendent",
			"District Admin",
			"Director Of Elementary Education",
			"Director Of Curriculum And Instruction",
			"Chief Academic Officer",
			"Curriculum Director"
		],
	}, {
		label: "Technology",
		options: [
			"Director Of Technology",
			"Chief Technology Officer",
			"Instructional Technology Specialist",
			"Director Of Information Technology",
			"Director Of Instructional Technology"
		],
	}, {
		label: "Accounting",
		options: [
			"Accounts Payable",
			"Bookkeeper"
		]
	}, {
		label: "PTA/PTO",
		options: [
			"PTO Officer"
		],
	}
]

CRMTitleSelector.propTypes = StrictPropTypes({
	value: PropTypes.string,
	onChange: PropTypes.func
});

module.exports = CRMTitleSelector;




// WEBPACK FOOTER //
// ./modules/components/utility/inputs/CRMTitleSelector.js